import React, { useState } from "react";
import { BsBuilding, BsCreditCard2Back, BsHeadset, BsPercent, BsShieldCheck, BsSpeedometer2 } from "react-icons/bs";
import SiteDetailsTab from "./tabs/SiteDetailsTab";
import SupportTab from "./tabs/SupportTab";
import PaymentTab from "./tabs/PaymentTab";
import TaxTab from "./tabs/TaxTab";
import SegmentTab from "./tabs/SegmentTab";
import VerificationTab from "./tabs/VerificationTab";

const TABS = [
    { key: "site", name: "Site Details", icon: <BsBuilding />, Component: SiteDetailsTab },
    { key: "support", name: "Support", icon: <BsHeadset />, Component: SupportTab },
    { key: "payment", name: "Payment", icon: <BsCreditCard2Back />, Component: PaymentTab },
    { key: "tax", name: "Tax & Fees", icon: <BsPercent />, Component: TaxTab },
    { key: "segment", name: "Segment Pricing", icon: <BsSpeedometer2 />, Component: SegmentTab },
    { key: "verification", name: "Customer Verification", icon: <BsShieldCheck />, Component: VerificationTab },
];

const Settings = () => {
    const [activeTab, setActiveTab] = useState(TABS[0].key);
    const ActiveComponent = TABS.find((tab) => tab.key === activeTab)?.Component || TABS[0].Component;

    return (
        <div className="settings-page">
            <div className="d-flex align-items-center justify-content-between flex-wrap gap-2 mb-3">
                <div>
                    <h4 className="fw-semibold mb-1">Business Settings</h4>
                    <p className="text-muted mb-0">Configure how the platform looks, charges, and verifies customers.</p>
                </div>
            </div>

            <div className="settings-layout">
                <div className="settings-tabs" role="tablist" aria-orientation="vertical">
                    {TABS.map((tab) => (
                        <button
                            key={tab.key}
                            type="button"
                            role="tab"
                            aria-selected={activeTab === tab.key}
                            className={`settings-tab-btn ${activeTab === tab.key ? "active" : ""}`}
                            onClick={() => setActiveTab(tab.key)}
                        >
                            <span className="settings-tab-icon">{tab.icon}</span>
                            {tab.name}
                        </button>
                    ))}
                </div>

                <div className="settings-tab-panel">
                    <ActiveComponent />
                </div>
            </div>
        </div>
    );
};

export default Settings;
